import Marionette from 'backbone.marionette';
import Navigator from 'app';
import journalVoteCompositviewTmpl from '../templates/journal_vote_compositview.tpl';
import JournalVoteItemview from './journal_vote_itemview';
import JournalVoteEmptyview from './journal_vote_emptyview';
export default Marionette.CompositeView.extend({
  template: journalVoteCompositviewTmpl,
  childView: JournalVoteItemview,
  emptyView: JournalVoteEmptyview,
  childViewContainer: "#daily-votes",
  initialize: function () {
    var self = this;
    Navigator.vent.on("event:day:change", function (index) {
      var date = Navigator.days.models[index].get("legislative_day_date");
      console.log("Show votes for:", date);
      var fetchingVotes = Navigator.request("vote:daily", date);
      $.when(fetchingVotes).done(function (votes) {
        self.collection = votes;
        self.render();
      });
    });
  }
});